<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <ul class="list-outside marker:w-24 marker:h-24">
    <slot />
  </ul>
</template>

<style scoped>
ul > :deep(li) {
  position: relative;
  list-style-type: none !important;

  &::before {
    content: '';
    display: block;
    height: theme("height.24");
    width: theme("width.24");
    background-size: theme("width.24");
    background-image: url('/images/tick.040424.svg');
    background-repeat: no-repeat;
    margin: theme("spacing.8") auto;
  }

  @screen tablet-wide {
      &::before {
        display: inline-block;
        left: -36px;
        margin-top: 0;
        position: absolute;
      }
    }
}

ul {
  @screen tablet-wide {
    margin-left: theme("spacing.32");
  }
}

</style>
